import type { Action } from 'redux';

export const RESET_DRILL_DOWN_DATA = 'RESET_DRILL_DOWN_DATA';

export const RESET_DRILL_DOWN_ACTION: ResetDrillDownDataAction = {
  type: RESET_DRILL_DOWN_DATA,
};

export const resetDrillDownData = (): ResetDrillDownDataAction => {
  return RESET_DRILL_DOWN_ACTION;
};

export type ResetDrillDownDataAction = Action<typeof RESET_DRILL_DOWN_DATA>;
